import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl, Tab, Tabs, Modal} from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { Bounce, Spinner } from 'react-activity';
import ReactNotification from 'react-notifications-component';
import NumberFormat from 'react-number-format';
import Cards from 'react-credit-cards';
import moment from 'moment'
import CardComponent from './Card';
import {ConvertDate} from '../../../Helpers/formatDate';
import { ModalDetails } from './Modals/ModalDetails';
import { AddCard } from './Cards/AddCard';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import '../index.css';
import Card from '../../../Images/Ejemplo_Tarjeta.png'

import DatePicker from "react-datepicker";

import RequestPin from './requestPin';
import Modaltwofa from '../../2fa';
import ModalRise from './Modals/ModalRise';

import Connection from '../../../Calls';
import Backend from '../../../Backend';

import "react-datepicker/dist/react-datepicker.css";
import icons from '../../Landing/icons.json'

import BlockIcon from '../../../Images/bloquear.svg';
import BlockedCard from '../../../Images/tarjeta-bloqueada.svg'
import UnblockIcon from '../../../Images/desbloquear.svg';
import DetailsIcon from '../../../Images/detalle.svg';
import DepositIcon from '../../../Images/deposito.svg';
import DepositGray from '../../../Images/depositar.svg';
import DepositBlue from '../../../Images/depositar-azul.svg';
import WithdrawalIcon from '../../../Images/retiro.svg';
import WithdrawalIconBlue from '../../../Images/retiro-azul.svg';
import CompraIcon from '../../../Images/compra.svg';
import SearchImage from '../../../Images/search.svg';
import WithOutMov from '../../../Images/movimientos.svg';
import CancelIcon from '../../../Images/cancelada.svg';
import CardPlaceholder from '../../../Images/card-placeholder-blue.png'
import { DigitalCard } from './Cards/DigitalCard';
import { PhysicalCard } from './Cards/PhysicalCard';
import { ModalBlock } from './Modals/ModalBlock';
import { ModalUnrecognized } from './Modals/ModalUnrecognized';
import AddCardIcon from '../../../Images/add_card.svg';
import VusdIcon from '../../../CryptoIcons/usd.svg';
import VmxnIcon from '../../../CryptoIcons/vmxn.svg';

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

export default class CardView extends Component {
  constructor(props){
    super(props)
    this.carrouselRef = React.createRef();
    var d = new Date();
    this.state = {
      tab:'card',
      start_date: moment().subtract(31, 'days').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      DpOrWd:'dp',
      unblocked:'blocked',
      transactions:[],
      filter:props.traductions.General.filtros.showAll,
      code:'-',
      amount:'',
      balanceInfo:{
        limit:0,
        deposit:0,
        withdrawal:0,
        available_deposit:0,
        available_withdrawal:0
      },
      cardImg: '',
      transaction_list: [],
      element: {},
      showDetailsModal:false,
      render_component: 'card',
      showModalBlock: false,
      showModalUnr: false,
      cards_list: [],
      currentCard:{},
      loading: false,
      date: '',
      load: false,
      slide:0,
      lastSlide:"empty",
      componentsHasMonted: false,
      cards_found: 0,
      vusdBtn: false,
      vmxnBtn: false,
      balance_virtual: 0,
      balance_virtual_mxn: 0,
      transactionLoad: false,
      showModalRise: false
    }

    this.TowFAConfirm=this.TowFAConfirm.bind(this)
    this.transactionList= this.transactionList.bind(this)
  }

  async componentWillMount(){
    this.setState({loading: true});
    await this.getCurrentCard();
    await this.loadCardInfo();
    await this.transactionHistory();
    this.getVirtualBalance();
    this.setState({loading: false});
  }

  async onCardChange() {
    this.setState({loading: true});
    await this.loadCardInfo();
    await this.transactionHistory();
    this.setState({loading: false});
  
}

  getVirtualBalance(){
    return new Promise((resolve, reject)=> {
      let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude;
      });
      result = latitude + longitude;
      Connection.EZcga8qH(
        confirmation,
        date,
        result,
        "XL7FefG",
        combination,
        "XCHF101",
        response => {
        Backend.BalanceVirtualExchange(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          response => {
          if (response.status.code === "0"){
            this.setState({
              balance_virtual: response.payload[0].balance,
              balance_virtual_mxn: response.payload[1].balance,
            })
            resolve(response.payload)
          } else {
            reject(response);
          }
        })
      })
    })
  }


  getCurrentCard(){
    return new Promise((resolve, reject) => {
      this.setState({loading: true});
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var payload = response.payload
        
        // Get array of cards
        Backend.GetCardsInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
          if (response.status.code === "0") {
            this.setState({
              cards_list: response.payload.cards_list,
              currentCard: this.state.lastSlide === 'empty' ? response.payload.cards_list[0]: response.payload.cards_list[this.state.lastSlide], 
              cards_found: response.payload.cards_found
            })
            this.setState({loading: false});
            resolve(response.status.code);
          } else{
            this.setState({loading: false});
            reject(response);
          }
        })
      })
    });
  }


  loadCardInfo(){
    return new Promise((resolve, reject) => {
      this.setState({loading: true});
      const {currentCard} = this.state
      const self = this;
      this.setState({historyLoad:true, load: true})
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var payload = response.payload
        if(currentCard !== 'disabled'){
          Backend.GetCardBalance(localStorage.getItem('email'), localStorage.getItem('token'), currentCard?.id, payload.r01, response => {
            if (response.status.code === "0") {
              this.setState({load: false})
              self.setState({
              cliente:response.payload.cliente,
              balance_mxn:response.payload.balance_mxn,
              balance_usd:response.payload.balance_usd,
              market_price:response.payload.market_price,
              bin:response.payload.bin,
              virtual_usd:response.payload.virtual_usd,
              unblocked:(response.payload.status == 'blocked')?false:true,
              balanceInfo:{
                limit:response.payload.deposits_limit,
                deposit_per_month: response.payload.deposits_available,
                deposit:response.payload.deposit_sum,
                withdrawal:response.payload.withdrawal_sum,
                available_deposit:response.payload.card_maxamount - response.payload.deposit_sum,
                available_withdrawal:response.payload.card_maxamount - response.payload.withdrawal_sum
              },
              date: response.payload.date,
                cardImg: response.payload.card_image
              });
              this.setState({loading: false});
              resolve(response.status.code);
            } else {
              this.setState({load: false})
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }

              });
              this.setState({loading: false});
              reject();
            }
            this.setState({loading: false});
          })
        } else {
          this.setState({loading: false});
          resolve();
        }
        // this.setState({load: false})
      })
    });
  }

  transactionHistory(){
    return new Promise((resolve, reject) => {
      this.setState({loading: true});
      const {currentCard} = this.state
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        if(currentCard !== 'disabled'){
          Backend.GetCardTransactions(localStorage.getItem('email'), localStorage.getItem('token'), currentCard?.id, this.state.start_date, this.state.end_date, response.payload.r01, response => {
            if (response.status.code === "0") {
              var arr = []
              switch (this.state.filter) {
                case this.props.traductions.General.filtros.showAll:
                  arr = response.payload.transactions
                  break;
                case this.props.traductions.General.filtros.Deposits:
                  arr = response.payload.transactions.filter(item => item.type === "deposit")
                  break;
                case this.props.traductions.General.filtros.Expense:
                  arr = response.payload.transactions.filter(item => item.type !== "deposit")
                  break;
                default:
              }
              this.setState({
                historyLoad:false,
                transactions:arr
              });
              this.transactionList(arr)
              this.setState({loading: false});
              resolve(response.status.code);
            }else{
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                this.setState({
                  historyLoad:false,
                  // transactions: [],
               });
               this.setState({loading: false});
               reject(response.status.description);
            };
          })
        } else {
          this.setState({loading: false, historyLoad:false});
          resolve();
        }
      })
    });
  }

  blockCard(){
    const {currentCard} = this.state;
    const self = this;
    if(this.state.blockSpinner)return;
    this.setState({blockSpinner:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      var action = (this.state.unblocked)?'block':'unblock'
      if(currentCard !== 'disabled' ){
        Backend.BlockCard(localStorage.getItem('email'), localStorage.getItem('token'), action, currentCard?.id, "P",payload.r01, response => {
          if (response.status.code === "0") {
            this.setState({
              unblocked:(this.state.unblocked)?false:true
            });
            this.setState({showModalBlock: false})
          }else{
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
              this.setState({showModalBlock: false})
          };
          this.setState({blockSpinner:false})
        })
      }
    })
  }

  TowFAConfirm(code){
    if(code =='cancel') this.setState({code:'-',showModalTwofa:false})
    else this.setState({code,showModalTwofa:false},()=>this.sendOperation(this.state.DpOrWd))

  }

  sendOperation(operation){
    const self = this;
    if(this.state.amount == '') {
      store.addNotification({
        title: "Error!",
        message: 'Enter a valid amount',
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      return
    }
    this.setState({transactionLoad:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload

      Backend.Check2FA(localStorage.getItem('email'),localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          if(response.payload.status == 'enabled' && this.state.code == '-'){
            this.setState({showModalTwofa:true,transactionLoad:false})
          }else{
            if(operation == 'dp'){
              this.sendDeposit(payload)
            }else{
              this.sendWithdrawal(payload)
            }
          }
        }else{
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.setState({transactionLoad:false})
        }
      });
    })
  }

  sendDeposit(payload){
    const {currentCard} = this.state;
    if (currentCard !== 'disabled'){
      let coin = this.state.vmxnBtn ? 'mxn' : 'usd'
      Backend.CardDeposit(localStorage.getItem('email'), localStorage.getItem('token'), currentCard?.id,this.state.amount, coin, this.state.code, payload.r01, response => {
        if (response.status.code === "0"){
          store.addNotification({
            title: "Success!",
            message: 'Deposit successful',
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.loadCardInfo();
          this.getVirtualBalance()
          this.setState({
            vusdBtn: false,
            vmxnBtn: false,
            amount: '',
          })
        }else{
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
        this.setState({code:'-',transactionLoad:false})
      })
    }
  }

  sendWithdrawal(payload){
    const {currentCard} = this.state;
    if (currentCard !== 'disabled'){
      let coin = this.state.vmxnBtn ? 'mxn' : 'usd'
      Backend.CardWithdrawal(localStorage.getItem('email'), localStorage.getItem('token'), currentCard?.id, this.state.amount, coin, this.state.code, payload.r01, response => {
        if (response.status.code === "0"){
          store.addNotification({
            title: "Success!",
            message: 'Withdrawal successful',
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.loadCardInfo()
          this.getVirtualBalance();
          this.setState({
            vusdBtn: false,
            vmxnBtn: false,
            amount: '',
          })
        }else{
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
        this.setState({code:'-',transactionLoad:false})
      })
    }
  }

  hideRequest(){
    this.setState({showRequest:false})
  }

  renderDate2(){
    const {currentCard} = this.state;
    return(
    <>
        <Col md={4} className='virtual_exchange_dropdown'>
          <Form.Label className="label-filters">{this.props.traductions.Card.enabled.L_DateFrom}:</Form.Label>
          <FormControl
            disabled={(currentCard === 'disabled')}
            type="date"
            id='start-date'
            className="custom-calendar"
            value={this.state.start_date}
            onChange={(start_date) => { this.setState({ start_date: moment(start_date.target.value).format('YYYY-MM-DD') }) }}
          />
        </Col>
        <Col md={4} className='virtual_exchange_dropdown'>
          <Form.Label className="label-filters">{this.props.traductions.Card.enabled.L_DateTo}:</Form.Label>
          <FormControl
            disabled={(currentCard === 'disabled')}
            type="date"
            id="end-date"
            className="custom-calendar"
            value={this.state.end_date}
            onChange={(end_date) => { this.setState({ end_date: moment(end_date.target.value).format('YYYY-MM-DD') }) }}
            />
        </Col>
        <Col style={{padding:0}} md={1}>
          <div style={{ paddingTop: 24, textAlign:'center'}}>
            <Button disabled={(currentCard === 'disabled')} className="btn-search" style={{ height: 40, width:40, padding: 0 }} onClick={() => { this.loadCardInfo(); this.transactionHistory() }}>
              <Image src={SearchImage} style={{ width: 20, marginTop:-4 }} />
            </Button>
          </div>
        </Col>
      </>
    );
  }

  transactionList(arr){
    const {transactions} = this.state
    let _finalData=[]
    let _stickyIndex=[]
    
    if (arr && arr.length > 0) {
      arr.map((item, i) => {
        if (i == 0 || item.date.substr(0,10) != transactions[i - 1].date.substr(0, 10)) {
          _stickyIndex.push(i + _stickyIndex.length);
          _finalData.push({
            Render_id: i.toString() + 'head',
            data: ConvertDate(item.date, localStorage.getItem('lan')),
            Render_type:'head'
          })
        }
        _finalData.push({
          Render_id: i.toString() + 'obj',
          Render_type:'obj',
          ...item
        })
        this.setState({transaction_list: _finalData})
      })
    } else {
      this.setState({transaction_list: []})
    }
  }

  GoToFiatWithdrawal(){
    this.props.data.history.push({
      pathname: '/withdrawal',
      state: { form_type:'Card' }
    })
  }

  getItemRow(item){
    this.setState({showDetailsModal: true, element: item})

  }

  clearStateModal(){
    this.setState({showDetailsModal: false, element: {}})
  }

  setRenderComponent(el){
    this.setState({render_component: el})
  }

  async currentCard(card){
    if(this.state.cards_list[card] !== undefined){
      await this.setState({currentCard: this.state.cards_list[card],slide: card})
      this.onCardChange();
    }else {
      this.setState({currentCard: 'disabled', slide: card})
    }
  }

  getSlide(element){
    if(element !== 'empty'){
      this.setState({lastSlide: element})
    } else {
      this.setState({lastSlide: 0})
    }
  }

  carrouselGoTo(index) {
    this.carrouselRef.current.slickGoTo(index);
  }

  showUnrecognizedModal() {
    this.setState({showModalUnr: true})
    this.clearStateModal()
  }

  hideUnrecognizedModal() {
    this.setState({showModalUnr: false})
  }

  hiddenModalRise() {
    this.setState({showModalRise: false})
  }

  render(){
    const {showDetailsModal, showModalBlock, currentCard, cards_list, date} = this.state
    const settings = {
      className: "center",
      dots: true,
      centerMode: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
    };
    return(
      <>
        <Container fluid>
        {this.state.loading ? (
        <div className="loader-container">
      	  <div className="spinner"></div>
        </div>
      ) : <></>}

          <div className="contenedor-wallets-generals">
            <Row style={{justifyContent: 'space-around'}}>
              {
                
                this.state.render_component === 'add_card' ?
                  <Col xl={4} md={10} lg={8} sm={12} className="container-cards" style={{display:'flex', justifyContent: 'center', padding: '', marginBottom: '10px'}}>
                    <div className='container-cards2'>
                      <AddCard 
                        loadCard={() => this.loadCardInfo()}
                        getCurrentCard={() => this.getCurrentCard()}
                        transactionHistory={() => this.transactionHistory()} 
                        getSlide={(e) => this.getSlide(e)}
                        slide={this.state.slide}
                        {...this.props} setRenderComponent={(e) => this.setRenderComponent(e)}
                      />
                    </div>
                  </Col>
                    :
                  <Col xl={5} lg={8} md={10} sm={12} className="container-cards" style={{display:'flex', justifyContent: 'center', marginBottom: '10px'}}>
                    {
                      this.state.render_component === 'physical_card' &&
                      <div className='container-cards2'>
                        <PhysicalCard
                          {...this.state}
                          {...this.props}
                          url={this.state.cardImg === '' ? CardPlaceholder : this.state.cardImg} 
                          setRenderComponent={(e) => this.setRenderComponent(e)}
                          getDate={(e) => this.getDate(e)}
                          getSlide={(e) => this.getSlide(e)}
                          onBlock={()=> this.setState({showModalBlock: true})}
                          slide={this.state.slide}
                        />
                      </div>
                    }
                    {
                      this.state.render_component === 'digital_card' &&
                      <div className='container-cards2'>
                        <DigitalCard
                          getSlide={(e) => this.getSlide(e)}
                          slide={this.state.slide}
                          current={this.state.currentCard} 
                          {...this.state} 
                          {...this.props}
                          url={this.state.cardImg === '' ? CardPlaceholder : this.state.cardImg}
                          setRenderComponent={(e) => this.setRenderComponent(e)}
                        />
                      </div>
                    }
                      {
                        this.state.render_component === 'card' &&
                        <>
                          <div className="container-cards1">
                              <div style={{marginBottom:44}}>
                                <div style={{marginBottom: '31.2px', marginTop: '54px'}}>
                                  {
                                    currentCard !== 'disabled' ?
                                    <Button onClick={() => this.setState({render_component: 'digital_card'})} className='card-digital'>{this.props.traductions.Card.enabled.L_Card_Digital}</Button>
                                    :
                                    <div style={{height: 44}}>
                                      <span>{this.props.traductions.Card.enabled.L_add_card}</span>
                                    </div>
                                  }
                                </div>
                                {/* carousel */}
                                  <center>
                                    <Slider ref={this.carrouselRef} initialSlide={this.state.lastSlide} afterChange={(e) => this.currentCard(e)} style={{width: '100%', maxWidth: '434px'}} {...settings}>
                                      {
                                        cards_list && cards_list.length > 0 && cards_list.map((card, index) => (
                                          <div style={{cursor: 'pointer'}}>
                                            <div onClick={() => this.carrouselGoTo(index)} style={{cursor: 'pointer', height: '233px', width: '100%', padding:' 0px 10px', display: 'flex', justifyContent: 'center', alignItems: 'center',filter: this.state.unblocked ? 'none' : 'opacity(0.5)'}}>
                                              {
                                                !this.state.unblocked &&
                                                <Image style={{position: 'absolute', zIndex: '1', marginLeft: 'auto', marginRight: 'auto'}} src={BlockedCard}/>
                                              }

                                              <Image src={`data:image/jpeg;base64,${card?.image}`} width={320} height={200}/>
                                              
                                              <div style={{position: 'absolute', zIndex: '0', height: '85%', display: 'flex', alignItems: 'center', width: card.status !== 'unblocked' ? '80px' : '15%', justifyContent: 'space-between'}}>
                                                <span style={{display: 'flex', alignItems: 'center', marginLeft: '-25px',color: card.type !== 'premium' ? '#fff': '#000'}}>
                                                  {'••••' + ' ' + card.bin}
                                                </span>
                                                <div style={{marginRight: '-45px'}}>
                                                  <span style={{color: card.type !== 'premium' ? '#fff': '#000'}}>{date}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      }
                                      {
                                        cards_list.length < this.state.cards_found && cards_list.length < 3 &&
                                        <div>
                                          <div onClick={() => this.carrouselGoTo(cards_list.length)} style={{height: '233px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                                            <Image src={AddCardIcon} height={'200px'}/>
                                            <div className='add-card-component'>
                                              <Button className='add-card-btn' onClick={() => this.setState({render_component: 'add_card'})}>{this.props.traductions.Card.enabled.Btn_new_Card}</Button>
                                            </div>
                                          </div>
                                        </div>        
                                      }
                                    </Slider>
                                  </center>
                                </div>
                            {
                              <>
                                {
                                  currentCard !== 'disabled' ? 
                                  (this.state.unblocked !== '') &&
                                  <p className='card-status' style={{marginBottom: '20px'}}>{this.props.traductions.Card.enabled.L_Status}: <span className={this.state.unblocked?'Unblocked':'Blocked'}>{(this.state.unblocked)?this.props.traductions.Card.enabled.L_StatusU:this.props.traductions.Card.enabled.L_StatusB}</span></p>
                                  :
                                  <div style={{height: '42px'}}></div>
                                }
                                <div style={{display: 'flex', justifyContent: 'space-between', padding: '0px 9px'}}>
                                  <Button disabled={currentCard === 'disabled'}className='gray-btn' onClick={() => this.setState({render_component: 'physical_card'})}><Image src={DetailsIcon} style={{marginRight: 6}}/>{this.props.traductions.Card.enabled.L_Detail}</Button>
                                  {
                                    currentCard === 'disabled' ?
                                    <Button disabled className={'gray-btn'}><Image src={BlockIcon} style={{marginRight: 6}}/>{this.props.traductions.Card.enabled.btn_StatusB}</Button>
                                      :
                                    <Button disabled={currentCard === 'disabled'} className={this.state.unblocked || this.state.unblocked === '' ? 'gray-btn' : 'black-btn'} onClick={()=> this.setState({showModalBlock: true})}><Image src={this.state.unblocked ? BlockIcon: UnblockIcon} style={{marginRight: 6}}/>{this.state.unblocked ? this.props.traductions.Card.enabled.btn_StatusB : this.props.traductions.Card.enabled.btn_StatusU}</Button>
                                  }
                                </div>
                                {/* TABS */}
                                <div className="tabs">
                                  <div style={ currentCard === 'disabled' ? {pointerEvents: 'none', opacity: 0.5}: {}} className={(this.state.DpOrWd=='dp')&&'active'} onClick={()=>this.setState({DpOrWd: 'dp'})}><Image src={this.state.DpOrWd === 'dp' ? DepositBlue : DepositGray} style={{marginRight: '11.63px'}}/>{this.props.traductions.Card.enabled.tab_deposit}</div>
                                  <div style={ currentCard === 'disabled' ? {pointerEvents: 'none', opacity: 0.5}: {}} className={(this.state.DpOrWd!='dp')&&'active'} onClick={()=>this.setState({DpOrWd: 'wd'})}><Image src={this.state.DpOrWd === 'wd' ? WithdrawalIconBlue : WithdrawalIcon} style={{marginRight: '11.63px'}}/>{this.props.traductions.Card.enabled.tab_Withdra}</div>
                                </div>
                                <div className="wrapper-responsive">
                                  <Button
                                    className={this.state.vusdBtn ? 'btn-vusd-card-active' : 'btn-vusd-card'}
                                    onClick={() => this.setState({vusdBtn: !this.state.vusdBtn, vmxnBtn: false})}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <Image src={VusdIcon} width={18} style={{marginRight: 5}}/>
                                      <span>Virtual USD</span>
                                    </div>
                                    <span>{formatMoney(this.state.balance_virtual)}</span>
                                  </Button>
                                  <Button className={this.state.vmxnBtn ? 'btn-vmxn-card-active' : 'btn-vmxn-card'} onClick={() => this.setState({vmxnBtn: !this.state.vmxnBtn, vusdBtn: false})}>
                                    <div>
                                      <Image src={VmxnIcon} width={18} style={{marginRight: 5}}/>
                                      <span>Virtual MXN</span>
                                    </div>
                                    <span>{formatMoney(this.state.balance_virtual_mxn)}</span>
                                  </Button>
                                </div>
                                <Row style={{justifyContent: 'center', marginTop: '27px'}}>
                                  <Col xl={7} style={{textAlign: 'center'}}>
                                    <Form.Label style={currentCard === 'disabled' ? {color: '#707070', opacity: 0.5} : {}} className="amount-label">{this.props.traductions.General.L_Amount}</Form.Label>
                                    <NumberFormat
                                      disabled={currentCard === 'disabled' || !this.state.vusdBtn && !this.state.vmxnBtn}
                                      className='Amount-input'
                                      placeholder={this.state.vmxnBtn ? this.props.traductions.General.P_Amount_MXN : this.props.traductions.General.P_Amount}
                                      decimalScale={2}
                                      thousandSeparator={true}
                                      prefix={'$'}
                                      suffix={this.state.vusdBtn ? ' USD' : ' MXN'}
                                      value={this.state.amount}
                                      onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amount:!this.state.vusdBtn && !this.state.vmxnBtn ? '' : value})}}
                                    />
                                  </Col>
                                </Row>
                                {this.state.DpOrWd =='dp' &&
                                  <div style={{margin: this.state.vusdBtn ? '18px 0px 20px' : '15px 0px 55px' }}>
                                    {
                                      this.state.vusdBtn &&
                                      <div>
                                        <span style={currentCard === 'disabled' ? {color: '#707070', opacity: 0.5} : {}}>$1 USD = {formatMoney(this.state.market_price)} MXN Aprox {formatMoney(this.state.amount * this.state.market_price)} MXN</span>
                                      </div>
                                    }
                                  </div>
                                }
                                {
                                  (this.state.DpOrWd=='dp') ?
                                  <Button
                                    disabled={(this.state.transactionLoad || this.state.balanceInfo.available_deposit == 0 || currentCard === 'disabled'|| !this.state.vusdBtn && !this.state.vmxnBtn)?true:false}
                                    onClick={()=>this.sendOperation(this.state.DpOrWd)}
                                    className={currentCard === 'disabled' ? "deposit-btn-disabled": "deposit-btn"}
                                  >
                                    {this.state.transactionLoad ? <Bounce size={20} color={"#FFFFFF"} animating={true} /> : this.props.traductions.Card.enabled.btn_Deposit}
                                  </Button>
                                    : 
                                  <Button 
                                    style ={{marginBottom: this.state.DpOrWd=='wd' && '72px' , marginTop:this.state.DpOrWd=='wd' && '55px' }}
                                    disabled={(this.state.transactionLoad || this.state.balanceInfo.available_withdrawal == 0 || currentCard === 'disabled' || !this.state.vusdBtn && !this.state.vmxnBtn)?true:false}
                                    onClick={()=>this.sendOperation(this.state.DpOrWd)} className={currentCard === 'disabled' ? "deposit-btn-disabled": "deposit-btn"}
                                    >
                                    {this.state.transactionLoad ? <Bounce size={20} color={"#FFFFFF"} animating={true} /> : this.props.traductions.Card.enabled.btn_withdra}
                                  </Button>
                                }
                                {
                                  (this.state.DpOrWd=='dp') &&
                                  <>
                                    <p style={currentCard === 'disabled' ? {color: '#707070', opacity: 0.50, marginTop:'10px',fontSize:'14px', marginBottom:'0px'} : {marginTop:'10px',fontSize:'14px', color: '#6E6B6B', marginBottom:'0px'}}>
                                      {this.props.traductions.Card.enabled.L_avlDeposit}: {formatMoney(this.state.balanceInfo.limit - (this.state.vmxnBtn ? this.state.amount/this.state.market_price : this.state.amount))} USD
                                    </p>
                                    <p style={currentCard === 'disabled' ? {color: '#707070', opacity: 0.50, marginTop:'10px',fontSize:'14px', marginBottom:'0px'} : {marginTop:'10px',fontSize:'14px', color: '#6E6B6B', marginBottom:'0px'}}>
                                      {this.props.traductions.Card.enabled.note_Deposit1}: {formatMoney(this.state.balanceInfo.deposit_per_month)} USD
                                    </p>
                                    <div style={{marginBottom: '10px'}}>
                                      <Button onClick={() => this.setState({showModalRise: true})} variant='link'>{this.props.traductions.Card.enabled.btn_Link_increase}</Button>
                                    </div>
                                  </>
                                }
                              </>
                            }
                          </div>
                        </>
                      }
                  </Col>
              }
              {/* wrapper Transactions */}
              <Col xl={7} lg={8} md={10} sm={12} className="container-cards" style={{marginBottom: '10px'}}>
                <div className="container-transactionsCard">
                  <Row>
                    <Col lg={12} md={12}>
                      <p style={{margin:'46px 0px 0px', color: '#707070', fontSize: '18px'}}>{this.props.traductions.Card.enabled.cardBalnce}</p>
                        {currentCard === 'disabled' ? 
                          <div>
                            <span className='card-balance-text'>{formatMoney(0)} MXN</span>
                            <span style={{marginLeft: '10px'}} className='card-balance-text'>Aprox {formatMoney(0)} USD</span>
                          </div>
                            :
                          <div>
                            <span className='card-balance-text'>{formatMoney(this.state.balance_mxn)} MXN</span>
                            <span style={{marginLeft: '10px'}} className='card-balance-text'>Aprox {formatMoney(this.state.balance_usd)} USD</span>
                          </div>
                        }
                    </Col>
                  </Row>
                  {/* <p>Operations</p> */}
                  <Row className="container-filter" style={{marginTop: '28.34px', marginBottom: '28.34px'}}>
                    <Col md={3}>
                      <Form.Label className="label-filters">{this.props.traductions.Card.enabled.L_operations}</Form.Label>
                      <FormControl disabled={(currentCard === 'disabled')} as='select' id='filters-transactions' onChange={(e) => {this.setState({filter: e.target.value})}}>
                        <option selected value={this.props.traductions.General.filtros.showAll}>{this.props.traductions.General.filtros.showAll}</option>
                        <option value={this.props.traductions.General.filtros.Expense}>{this.props.traductions.General.filtros.Expense}</option>
                        <option value={this.props.traductions.General.filtros.Deposits}>{this.props.traductions.General.filtros.Deposits}</option>
                      </FormControl>
                    </Col>
                    {this.renderDate2()}
                  </Row>
                  {
                    currentCard !== 'disabled' ?
                    <span style={{fontSize: '18px', fontWeight: '600'}}>{this.props.traductions.Card.enabled.L_Transaction}</span>
                    : <></>
                  }
                  <Row>
                    <div className='transactions-container' style={{margin:'12px', width:'100%', height:'585px', overflowY:'scroll', overflowX: 'hidden'}}>
                      {
                        currentCard !== 'disabled' && this.state.transaction_list && this.state.transaction_list.length > 0 ? this.state.transaction_list.map((item) => (
                          <>
                            {
                              item.Render_type === 'head' &&
                              <div className="header-sticky">{item.data}</div>
                            }
                            {
                              item.Render_type === "obj" &&
                              <Row className="row-table" onClick={() =>  this.getItemRow(item)}>
                                <Col xl={1} sm={2}>
                                {
                                  item?.type !== 'unknown' ?
                                  <Image src={(item.type ===  "deposit")?DepositIcon:CompraIcon} className='money-icon'/>
                                    : 
                                  <Image src={CancelIcon} className='money-icon'/>
                                }
                                </Col>
                                <Col xl={6} sm={8}>
                                  <div>
                                    <span>{item.description}</span>
                                  </div>
                                  <div>
                                  {item.commerce !== '' && <span className='text-ecom-transaction'>{item.commerce}</span>}
                                  </div>
                                </Col>
                                <Col xl={5} sm={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                                  <span>{item.type !== "deposit" && "-"}{formatMoney(item?.amount)}</span>
                                </Col>
                              </Row>
                            }
                          </>
                        ))
                        :
                        <>
                          <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                            <Image src={WithOutMov} width="332px"/>
                            <span style={{color: '#A2A2A2'}}>{this.props.traductions.Card.enabled.L_empty_transactions_1}</span>
                            <span style={{color: '#A2A2A2'}}>{this.props.traductions.Card.enabled.L_empty_transactions_2}</span>
                          </div>
                        </>
                      }                      
                    </div>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <ModalRise {...this.props} {...this.state} show={this.state.showModalRise} traductions={this.props.traductions} hiddenModalRise={() => this.hiddenModalRise()}/>
        <RequestPin show={this.state.showRequest} hideRequest={this.hideRequest.bind(this)} traductions={this.props.traductions}/>
        <Modaltwofa modal showModalTwofa={this.state.showModalTwofa} TowFAConfirm={this.TowFAConfirm} traductions={this.props.traductions}/>
        <ModalDetails {...this.props} show={showDetailsModal} showUnrecognizedModal={() => this.showUnrecognizedModal()} handleClose={() => this.clearStateModal()} item={this.state.element}/>
        <ModalBlock {...this.props} {...this.state} show={showModalBlock} block={() => this.blockCard()} closeModal={() => this.setState({showModalBlock: false})} spinner={this.state.blockSpinner}/>
        <ModalUnrecognized {...this.props} show={this.state.showModalUnr} hideModal={() => this.hideUnrecognizedModal()} showUnrecognizedModal></ModalUnrecognized>
      </>
    )
  }
}
